export default __webpack_public_path__ + "static/two-ef4b398c5d0e919471bed55b04be66be.png";